import React, {PropTypes} from 'react';
import ClassNames from 'classnames';

import './TextareaControl.scss';

class TextareaControl extends React.Component {

    static propTypes = {
        rows: PropTypes.number,
        placeholder: PropTypes.string,
        textareaClassName: PropTypes.string,
        onChange: PropTypes.func,
        value: PropTypes.string,
        label: PropTypes.string,
    }

    static defaultProps = {
        rows: 3,
        label: '',
    }

    _onChange = (event) => {
        if (this.props.onChange) {
            this.props.onChange(event, event.target.value);
        }
    }

    render() {

        var classes = ClassNames(
            this.props.className,
            'TextareaControl'
        );

        var textareaClassName = ClassNames(
            this.props.textareaClassName,
            'TextareaControl-textarea'
        );

        var label;

        if (this.props.label) {
            label = (
                <label className="TextareaControl-label" htmlFor={this.props.id}>
                    {this.props.label}
                </label>
            );
        }

        return (
            <div className={classes}>
                {label}
                <textarea className={textareaClassName}
                    id={this.props.id}
                    rows={this.props.rows}
                    value={this.props.value}
                    placeholder={this.props.placeholder}
                    onChange={this._onChange} />
            </div>
        );
    }

}

export default TextareaControl;



// WEBPACK FOOTER //
// ./client/components/TextareaControl/TextareaControl.js